import { get } from 'lodash'
import * as Actions from '../actions'

const INITIAL_STATE = { userData: {}, approvedProductList: [] }
const updatedUserFieldState = (state, fieldData) => ({
  ...state,
  userData: { ...state.userData, ...fieldData },
})

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Actions.SET_USER_RESPONSE:
      return updatedUserFieldState(state, action.data)

    case Actions.SET_INITIAL_REG_ITEMS:
      return { ...state, initialRegItems: action.initialRegItems }

    case Actions.SET_APPROVED_PRODUCT_RECOMMENDATION:
      return { ...state, approvedProductList: action.approvedProductList }

    default:
      return state
  }
}
export const getUserFields = (state) => state.userData
export const getIsHavingMultipleBabies = (state) =>
  getUserFields(state).isHavingMultipleBabies
export const getSentiment = (state) => getUserFields(state).sentiment
export const getUserWantsToAddItemsFromAnyStore = (state) =>
  getUserFields(state).userWantsToAddItemsFromAnyStore

export const getInitialRegItems = (state) => get(state, 'initialRegItems')
export const getApprovedProductRecommendations = (state) =>
  get(state, 'approvedProductList')
